import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicantFilterModel } from 'common/models/page-models/applicants/applicant-table/applicant-filter-data.model';
import { ApplicantFilterMetaModel } from 'common/models/page-models/applicants/applicant-table/applicant-filter-form-meta.model';
import { ApplicantsModel, ApplicantsListingModel } from 'common/models/page-models/applicants/applicant-table/applicant-grid.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ApplicantsWidgetService } from 'common/widget/applicant-dashboard/application.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicantsResolver extends GridResolver<
  ApplicantsModel,
  ApplicantsListingModel
> {
  constructor(
    protected fs: ApplicantsWidgetService,
    protected override router: Router,
    protected override systemService: SystemService
  ) {
    super(fs, router, systemService);
  }
  override initWidget(envelopeType: any, transferData: any): WidgetModel {
    const widget = new GridWidgetModel();
    const metaModel = this.pageService.getMetaModel();
    widget.recordPerPage = metaModel.properties?.recordPerPage;
    widget.searchableFeilds = metaModel.properties?.searchableFields;
    transferData.filterData = new ApplicantFilterModel();
    transferData.filterMeta = new ApplicantFilterMetaModel().getMetaModel();
   // this.fs.getFilterOptions(transferData.filterMeta);
    widget.transferData = transferData;
    return widget;
}


}
